// extracted by mini-css-extract-plugin
module.exports = {"topModal":"ModalProvider_topModal__2g7kB","modal":"ModalProvider_modal__14fja"};